"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomBarWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _BottomNavigation = _interopRequireDefault(require("@material-ui/core/BottomNavigation"));

var _BottomNavigationAction = _interopRequireDefault(require("@material-ui/core/BottomNavigationAction"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _reactDeviceDetect = require("react-device-detect");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    bottomWrapper: {
      position: 'fixed',
      width: '100%',
      bottom: 0,
      boxShadow: "0px 6px 8px 4px ".concat(theme.palette.text.primary),
      zIndex: 2000
    },
    bottomIOS: {
      position: 'fixed',
      width: '100%',
      bottom: 0,
      boxShadow: "0px 6px 8px 4px ".concat(theme.palette.text.primary),
      zIndex: 2000,
      height: 56,
      alignItems: 'start'
    },
    paragraph: {
      margin: 0,
      fontSize: 12,
      color: theme.palette.text.secondary
    },
    paragraphActive: {
      margin: 0,
      fontSize: 12,
      color: theme.palette.primary.main
    },
    bottomButtons: {
      maxWidth: 298
    }
  };
});

var BottomBarWidget = function BottomBarWidget(props) {
  var items = props.items,
      hide = props.hide,
      hidden = props.hidden,
      className = props.className;
  var classes = useStyles();
  if (hide) return null;
  return /*#__PURE__*/_react.default.createElement(_Hidden.default, hidden, /*#__PURE__*/_react.default.createElement(_BottomNavigation.default, {
    showLabels: true,
    className: (0, _classnames.default)([_reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper, className])
  }, items.map(function (item) {
    var isActive = item.isActive,
        label = item.label,
        Icon = item.icon,
        onClick = item.onClick;
    return /*#__PURE__*/_react.default.createElement(_BottomNavigationAction.default, {
      key: label,
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: isActive ? classes.paragraphActive : classes.paragraph
      }, label),
      icon: /*#__PURE__*/_react.default.createElement(Icon, {
        color: isActive ? 'primary' : 'default'
      }),
      onClick: onClick,
      classes: {
        root: classes.bottomButtons
      }
    });
  })));
};

exports.BottomBarWidget = BottomBarWidget;
BottomBarWidget.propTypes = {
  /** Array de itens  */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    icon: _propTypes.default.oneOfType([_propTypes.default.objectOf(_propTypes.default.any), _propTypes.default.func]),
    isActive: _propTypes.default.bool
  })).isRequired,

  /** classes de css para customizar o componente */
  className: _propTypes.default.string,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  })
};
BottomBarWidget.defaultProps = {
  className: '',
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  }
};